import React from "react";
import { PageBanner, SectionTitle } from "../components/Shared";
import Icon from "../components/Icon";
import { CAMPUS_DATA } from "../data/siteData";
import "./InnerPages.css";

const CampusPage = () => {
  return (
    <>
      <PageBanner title="Campus Facilities" breadcrumb="Campus" />
      <section className="section">
        <div className="container">
          <SectionTitle
            title="Our Campus"
            subtitle="State-of-the-art infrastructure designed for a modern learning experience."
          />
          <div className="campus-list">
            {CAMPUS_DATA.map((c, i) => (
              <div
                key={c.title}
                className={`campus-row ${i % 2 !== 0 ? "campus-row--reverse" : ""}`}
              >
                <img src={c.img} alt={c.title} className="campus-row__img" />
                <div className="campus-row__text">
                  <h3 className="campus-row__title">
                    <Icon name={c.icon} size={22} /> {c.title}
                  </h3>
                  <p>{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default CampusPage;
